export const formatString = (source: string, replacements: string[]) => {
    return source.replace(/{([0-9]+)}/g, function(match, index) {
        // eslint-disable-next-line security/detect-object-injection
        return typeof replacements[index] === 'undefined' ? match : replacements[index];
    });
};
